import { SourceLinks } from '@/components/ui/source-links';
import { Users } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';
import { useState } from 'react';

interface OriginalAudienceCardProps {
    audience: {
        primaryAudience: string;
        socialContext: string;
        religiousContext?: string;
        sources?: Source[];
    };
    isExpanded?: boolean;
    onToggleExpansion?: () => void;
    defaultExpanded?: boolean;
    title?: string;
}

export function OriginalAudienceCard({
    audience,
    isExpanded: controlledIsExpanded,
    onToggleExpansion: controlledOnToggleExpansion,
    defaultExpanded = false,
    title = "Original Audience"
}: OriginalAudienceCardProps) {
    const [internalIsExpanded, setInternalIsExpanded] = useState(defaultExpanded);

    const isExpanded = controlledIsExpanded !== undefined ? controlledIsExpanded : internalIsExpanded;
    const onToggleExpansion = controlledOnToggleExpansion !== undefined
        ? controlledOnToggleExpansion
        : () => setInternalIsExpanded(!internalIsExpanded);

    return (
        <DiscoveryCard
            isExpanded={isExpanded}
            onToggle={onToggleExpansion}
            title={title}
            icon={Users}
        >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mt-6 px-1">
                <div className="space-y-1.5">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">Primary Audience</div>
                    <p className="text-sm text-foreground/70 font-light leading-relaxed">{audience.primaryAudience}</p>
                </div>
                <div className="space-y-1.5 border-l border-primary/10 pl-6">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">Social Context</div>
                    <p className="text-sm text-foreground/70 font-light leading-relaxed">{audience.socialContext}</p>
                </div>
                {audience.religiousContext && (
                    <div className="space-y-1.5 border-l border-primary/10 pl-6 md:col-span-2">
                        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">Religious Context</div>
                        <p className="text-sm text-foreground/70 font-light leading-relaxed">{audience.religiousContext}</p>
                    </div>
                )}
            </div>
            {audience.sources && audience.sources.length > 0 && (
                <div className="pt-4 border-t border-border/10">
                    <SourceLinks sources={audience.sources} />
                </div>
            )}
        </DiscoveryCard>
    );
}
